import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"
import { Card, Col, Container } from 'reactstrap'
import { BackButton } from '../../../components/Common/BackButton'
import Breadcrumb from '../../../components/Common/Breadcrumb'
import { NewRegisterButton } from '../../../components/Common/NewRegisterButton'
import { SearchBar } from '../../../components/Common/SearchBar'
import Table1 from "../../../components/Common/TableContainer"
import { TableItemDeleteModal } from '../../../components/Common/TableItemDeleteModal'
import { addNewNorm, deleteNorm, getLabTypes, getNorms, getTypesRegulations, updateNorm, updateNormStatus } from '../../../store/actions'
import { NormRegisterModal } from './NormRegisterModal'

export const CatalogLayoutNorms = (props) => {

    // * Redux
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getLabTypes("?limit=1000&page=0"));
        dispatch(getTypesRegulations("?limit=20&page=0"))
        dispatch(getNorms("?limit=20&page=0"));
    }, [])

    const { norms, loading, total, currentPage, labtypes, typesRegulations } = useSelector(state => ({
        norms: state.norms.norms,
        loading: state.norms.loading,
        norm: state.norms.norm,
        total: state.norms.total,
        currentPage: state.norms.currentPage,
        labtypes: state.labType.labtypes,
        typesRegulations: state.typesRegulations.typesRegulations,
    }));
    // * Redux fin

    // Modal HOOKS
    const [isUpdate, setIsUpdate] = useState(false);
    const [rowInfo, setRowInfo] = useState();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [searchDataNorm, setSearchDataNorm] = useState('');

    useEffect(() => {
        dispatch(getNorms(`?limit=20&page=0&search=${searchDataNorm}`))
    }, [searchDataNorm])

    const onUpdate = (values) => {
        setIsUpdate(true)
        setRowInfo(values)
        setShowModal1(true)
    }

    const onDelete = (values) => {
        setRowInfo(values)
        setShowModal2(true)
    }

    const columns = React.useMemo(
        () => [
            {
                Header: 'Tipo de laboratorio',
                accessor: 'laboratoryType.name',
                width: 50,
            },
            {
                Header: 'Tipo de normativa',
                accessor: 'typesRegulation.name',
                width: 50,
            },
            {
                Header: 'Norma',
                accessor: 'name',
                width: 50,
            },
            {
                Header: 'Descripción de norma',
                accessor: 'description',
                width: 50,
            },
            {
                Header: 'Estatus',
                width: '15%',
                Cell: ({ row }) => (
                    row.original.recordStatus == true ?
                        <div className='text-success'>Activo</div> :
                        <div className='text-danger'>Inactivo</div>
                ),
            },
            {
                width: '10%',
                Header: "Acciones",
                Cell: ({ row }) => (
                    <div className="page-title-box d-flex align-items-center justify-content-center">
                        <button className="btn btn-outline-secondary text-primary mx-1 rounded-3 p-0 me-2" onClick={() => { onUpdate(row.original) }}>
                            <span className="mdi mdi-18px mdi-lead-pencil p-2"></span>
                        </button>
                        <button className="btn btn-outline-secondary text-danger mx-1 rounded-3 p-0" onClick={() => { onDelete(row.original) }}>
                            <span className="mdi mdi-18px mdi-delete p-2"></span>
                        </button>
                    </div>
                ),
            },
        ],
        []
    )

    const RegisterModalRespInfo = (values, active) => {
        if (isUpdate) {
            const updValue = { ...values, id: rowInfo.id }
            dispatch(updateNorm(updValue))
            dispatch(updateNormStatus({
                id: rowInfo.id,
                recordStatus: active,
            }));
        } else {
            dispatch(addNewNorm(values))
        }
        setTimeout(() => {
            dispatch(getNorms("?limit=20&page=0"))
        }, 500)
        setIsUpdate(false)
        setRowInfo('')
    }

    const modalClose = () => {
        setIsUpdate(false)
    }

    const onDeleteConfirmation = () => {
        dispatch(deleteNorm(rowInfo))
        setRowInfo('')
    }

    const getPagination = (params) => {
        dispatch(getNorms(`${params}&search=${searchDataNorm}`))
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid className="" >
                    <Col className="col-12" style={{ padding: 40 }}>
                        <Card className='' style={{ padding: 20 }}>

                            <Breadcrumb breadcrumbItem1='catalogsmenu' breadcrumbItem2='NormsCatalog' />

                            <Card className='' style={{ padding: 20 }}>

                                <div className='pe-1'>
                                    <BackButton props={props} />
                                </div>

                                <div className="row">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9col-xxl-9 mb-2 ps-3 pe-3">
                                        <SearchBar setSearchData={setSearchDataNorm} />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-3 col-xl-3 col-xxl-3 pe-3">
                                        <NewRegisterButton setShowModal={setShowModal1} showModal={showModal1} />
                                    </div>
                                </div>

                                <div className='ms-1'>
                                    <Table1 currentPage={currentPage} getPagination={getPagination} total={total} loading={loading} isAddTableBorderStrap columns={columns} data={norms} />
                                </div>
                                
                                <NormRegisterModal
                                    typesRegulation={typesRegulations}
                                    labTypes={labtypes}
                                    rowInfo={rowInfo}
                                    modalClose={modalClose}
                                    isUpdate={isUpdate}
                                    modalRespInfo={RegisterModalRespInfo}
                                    setShowModal={setShowModal1}
                                    showModal={showModal1}
                                />

                                <TableItemDeleteModal onDeleteConfirmation={onDeleteConfirmation} props={props} setShowModal={setShowModal2} showModal={showModal2} modalHeader='Eliminar normas' modalBodyLabel='¿Está seguro que desea eliminar la norma seleccionada?' />

                            </Card>

                            <br />
                            <br />

                        </Card>
                    </Col>
                    <ToastContainer autoClose={2000} newestOnTop={true} />
                </Container>
            </div>
        </React.Fragment>
    )
}
